import { Plus, X } from "lucide-react";
import { fmtUSD } from "../../lib/api";
import { clampAmt, fmtMult, entryOf } from "./calc";
import { AssetSelect, EntrySelect } from "./Selects";

export function Basket({ assets, testid, rows, updateRow, addRow, removeRow, totals }) {
  return (
    <div>
      <div className="space-y-4">
        {rows.map((r, i) => {
          const a = assets.find((x) => x.id === r.assetId);
          const e = entryOf(a, r.entryId);
          return (
            <div key={r.key} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_140px_auto] gap-3 items-center hairline pt-4 first:border-t-0 first:pt-0" data-testid={`${testid}-row-${i}`}>
              <AssetSelect assets={assets} value={r.assetId} onChange={(v) => updateRow(r.key, { assetId: v })} tid={`${testid}-row-${i}-asset`} />
              <EntrySelect a={a} value={r.entryId} onChange={(v) => updateRow(r.key, { entryId: v })} tid={`${testid}-row-${i}-entry`} />
              <input className="input-solera fig" type="number" min={1000} step={1000} value={r.amount}
                onChange={(ev) => updateRow(r.key, { amount: clampAmt(Number(ev.target.value)) })} data-testid={`${testid}-row-${i}-amount`} />
              <div className="flex items-center gap-4 justify-end">
                <span className="fig t-small text-[#C69A4E] whitespace-nowrap">{fmtUSD(clampAmt(r.amount) * (e?.multiple || 1))}</span>
                <button onClick={() => removeRow(r.key)} className="text-muted-s hover:text-bone" data-testid={`${testid}-remove-${i}`} aria-label="Remove"><X size={16} /></button>
              </div>
            </div>
          );
        })}
      </div>
      <button onClick={addRow} className="t-label hover:!text-[#E8E6E1] flex items-center gap-2 mt-5" data-testid={`${testid}-add-row`}><Plus size={14} /> Add a position</button>

      <div className="gapped-enclosure p-6 sm:p-8 mt-8 grid sm:grid-cols-3 gap-6" data-testid={`${testid}-basket-total`}>
        <div>
          <span className="t-label">Total invested</span>
          <div className="fig t-body text-bone mt-1">{fmtUSD(totals.invested)}</div>
        </div>
        <div>
          <span className="t-label">Blended multiple</span>
          <div className="fig t-body text-bone mt-1">{fmtMult(totals.moic)}</div>
        </div>
        <div>
          <span className="t-label">Projected value</span>
          <div className="fig mt-1 text-[#C69A4E]" style={{ fontSize: 28, lineHeight: 1 }}>{fmtUSD(totals.projected)}</div>
        </div>
      </div>
    </div>
  );
}
